// Shared pagination helpers for master-data list pages (CourseLevelPage,
// CourseCataloguePage, ModuleMasterPage, and future pages with the same
// "Showing X-Y of Z" footer + page-size selector + pager).
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 'All'];

// Compact page-number list with ellipses for long ranges, e.g. [1, '…', 4, 5, 6, '…', 12].
export function buildPageList(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = new Set([1, total, current, current - 1, current + 1]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const result = [];
  let prev = null;
  for (const p of sorted) {
    if (prev !== null && p - prev > 1) result.push('…');
    result.push(p);
    prev = p;
  }
  return result;
}
